import React, { useMemo } from 'react';
import { FormGroup } from 'src/components/ui';
import Icon from 'src/components/Icon';
import { useJnx } from '../../util/jnx';
import { concatenatePaths } from '../../util/mapObject';
import { useSideChannelSubscription } from '../../util/useSideChannel';
import getPathFromId from '../../util/getPathFromId';
import useTestId from '../../hooks/useTestId';

function IconCheckField(props) {
  const {
    formData,
    registry,
    readonly: propReadonly,
    disabled,
    fieldPathId: { $id },
    schema: { icon = 'Check' },
    uiSchema: {
      'ui:checkBoxClassName': className = 'btn-secondary',
      'ui:checkBoxCheckedClassName': checkedClassName = 'btn-success',
      'ui:readonly': uiReadonly,
      'ui:onChange': onChangeExpr,
      'ui:dontToggle': dontToggle,
      'ui:exclusiveCheckgroup': exclusiveCheckgroup,
    },
    required,
    onChange: propOnChange,
  } = props;
  const formContext = registry?.formContext;
  const { setFormDataValues, sideChannel, openModal } = formContext;

  const readonly = propReadonly || uiReadonly;
  const testIdProps = useTestId($id);

  const rootFormData = useSideChannelSubscription(sideChannel, 0) || {};
  const path = useMemo(() => getPathFromId($id), [$id]);

  const jnxOnChange = useJnx(
    onChangeExpr,
    (_, onChangeJnx) => {
      if (onChangeJnx)
        onChangeJnx.evalAsync(rootFormData, path, {
          openModal,
        });
    },
    [openModal, path, rootFormData]
  );

  function onClick(e) {
    e.preventDefault();
    e.stopPropagation();

    if (readonly || disabled) return;

    const newValue = dontToggle ? true : !formData;

    if (exclusiveCheckgroup && newValue) {
      const dataValues = exclusiveCheckgroup.reduce(
        (_, otherCheckRelPath) => {
          const otherPath = concatenatePaths(path, otherCheckRelPath);
          _[otherPath] = false;

          return _;
        },
        {
          [path]: true,
        }
      );
      setFormDataValues(dataValues);
    } else {
      propOnChange(newValue, path);
    }

    if (jnxOnChange) jnxOnChange();
  }

  return (
    <FormGroup disabled={readonly || disabled} className="form-group-icon-check-field">
      <button
        id={$id}
        {...testIdProps}
        className={`icon-check-field btn ${checkedClassName && formData ? checkedClassName : className} ${formData ? 'checked' : ''}`}
        color="secondary"
        disabled={readonly || disabled}
        required={required}
        onClick={onClick}
      >
        {formData ? <Icon icon={icon} /> : <span> </span>}
      </button>
    </FormGroup>
  );
}

export default IconCheckField;
